import React, { useMemo, useState } from "react";
import { Header, SendReminderButton } from "./styles";
import CardAngularGradient from "components/v1/CardAngularGradient";
import { Ptag } from "components/core";
import Celebration from "assets/svgs/celebration.svg";
import SendReminder from "assets/svgs/send_reminder.svg";
import useUser from "hooks/useUser";
import { formatNumberToIndian } from "utlis/utils";

function HeaderView({
  logged_in_employee_count,
  active_employee_count,
  sendReminder,
}) {
  const { getRole } = useUser();

  const showSendReminder = useMemo(() => {
    const role = getRole();
    return (
      logged_in_employee_count !== active_employee_count && role !== "admin"
    );
  }, [logged_in_employee_count, active_employee_count]);
  if (logged_in_employee_count == null && active_employee_count == null) return null;
  return (
    <Header>
      <CardAngularGradient title="Total Active Employees" bgImg={Celebration}>
        <Ptag color="#161E54" fontWeight="600" fontSize="32px">
          {formatNumberToIndian(active_employee_count)}
        </Ptag>
      </CardAngularGradient>
      <CardAngularGradient title="Employees Logged In" bgImg={SendReminder}>
        <div
          style={{
            display: "flex",
            alignItems: "flex-end",
          }}
        >
          <Ptag color="#161E54" fontWeight="600" fontSize="32px">
            {formatNumberToIndian(logged_in_employee_count)}
          </Ptag>
        </div>
        {showSendReminder && (
          <SendReminderButton
            variant="contained"
            disableElevation
            onClick={sendReminder}
            // disabled={logged_in_employee_count == active_employee_count}
          >
            Send Reminder
          </SendReminderButton>
        )}
      </CardAngularGradient>
    </Header>
  );
}

export default HeaderView;
